// Interface language switcher (the EN/NL buttons in the account menu).
//
// Saving the choice is a PATCH; showing it needs a full reload, because every
// string on the page was rendered server-side in the previous language. Same
// shape as the theme switch in custom/theme.js, minus the live class swap —
// there is no client-side equivalent of re-rendering the copy.
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-set-locale]')
  if (!btn) return
  e.preventDefault()
  const locale = btn.dataset.setLocale
  if (!locale || btn.classList.contains('active')) return

  const token = document.querySelector('meta[name="csrf-token"]')
  btn.disabled = true
  fetch('/locale/' + encodeURIComponent(locale), {
    method: 'PATCH',
    headers: { 'X-CSRF-Token': token ? token.content : '', Accept: 'application/json' },
    credentials: 'same-origin'
  }).then(function (r) {
    if (!r.ok) throw new Error('HTTP ' + r.status)
    window.location.reload()
  }).catch(function () { btn.disabled = false })
})
